import React, { useState, useEffect, useCallback, useRef } from "react";
import { producaov2 as api } from "../../../services/apis";
import { Icon } from "semantic-ui-react";
import {
  Container,
  Content,
  Title,
  ContainerInputSearch,
  Input,
  SemanticTable,
  SemanticButton,
  ContainerPaginate,
  ButtonIcon,
} from "./styled";
import swal from "sweetalert";
import { withRouter } from "react-router-dom";
import AdminMenu from "../../../components/Admin/MenuDetalhes/AdminMenu";
import { isAuthAdmin } from "../../../services/auth";
import { Box } from "@material-ui/core";

const LogsVoittoCoins = (props) => {
  const [alunos, setAlunos] = useState([]);
  const [search, setSearch] = useState("");
  const currentPage = useRef(1);

  useEffect(() => {
    loadAuth();
    loadVoittoCoin();
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const loadVoittoCoin = async () => {
    await api
      .get(
        `logVoittoCoin/add/alunos?search=${search}&page=${currentPage.current}`
      )
      .then((res) => {
        setAlunos(res.data);
      })
      .catch((err) => {
        console.error(err);
        swal("Não foi possível carregar os alunos", "", "");
      });
  };

  const cleanAll = useCallback(() => {
    setSearch("");
    currentPage.current = 1;
    loadVoittoCoin();
  });

  const sendSearch = (e) => {
    setSearch(e);
    currentPage.current = 1;
    loadVoittoCoin();
  };

  const changePage = (e) => {
    if (e > 0) {
      currentPage.current = currentPage.current + 1;
      loadVoittoCoin();
    } else {
      if (currentPage.current != 1) {
        currentPage.current = currentPage.current - 1;
        loadVoittoCoin();
      }
    }
  };

  return (
    <Box width="100%" paddingLeft="250px">
      <Box width="100%" padding="1rem">
          <AdminMenu />
            <Title>Logs VoittoCoins</Title>

            <ContainerInputSearch className="ui fluid left icon input">
              <Input
                type="search"
                placeholder="Procurar por aluno"
                value={search}
                onChange={(e) => sendSearch(e.target.value)}
              />
              <Icon name="search icon" />
              <SemanticButton color="secundary" onClick={cleanAll}>
                Limpar
              </SemanticButton>
            </ContainerInputSearch>

            <SemanticTable size="big" celled>
              <SemanticTable.Header>
                <SemanticTable.Row>
                  <SemanticTable.HeaderCell>ID </SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell>Nome </SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell>Email </SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell>
                    voittocoin
                  </SemanticTable.HeaderCell>
                  <SemanticTable.HeaderCell>Ações </SemanticTable.HeaderCell>
                </SemanticTable.Row>
              </SemanticTable.Header>

              <SemanticTable.Body>
                {alunos
                  .filter(
                    (aluno) =>
                      aluno.id.toString().includes(search) ||
                      aluno.nome.toLowerCase().includes(search.toLowerCase()) ||
                      aluno.email.toLowerCase().includes(search.toLowerCase())
                  )
                  .map((aluno, index) => (
                    <SemanticTable.Row>
                      <SemanticTable.Cell>{aluno.id}</SemanticTable.Cell>
                      <SemanticTable.Cell>{aluno.nome}</SemanticTable.Cell>
                      <SemanticTable.Cell>{aluno.email}</SemanticTable.Cell>
                      <SemanticTable.Cell>
                        {aluno.voitto_coins !== null
                          ? aluno.voitto_coins.voittocoins
                          : 0}
                      </SemanticTable.Cell>
                      <SemanticTable.Cell>
                        <>
                          <ButtonIcon
                            onClick={() =>
                              window.open(
                                `/admin/logsVoittoCoin/detalhes/${aluno.id}`
                              )
                            }
                          >
                            <Icon name="edit" color={"blue"} />
                          </ButtonIcon>
                        </>
                      </SemanticTable.Cell>
                    </SemanticTable.Row>
                  ))}
              </SemanticTable.Body>
            </SemanticTable>
            <ContainerPaginate>
              <SemanticButton
                color="grey"
                icon
                labelPosition="left"
                onClick={() => changePage(-1)}
              >
                Voltar
                <Icon name="left arrow" />
              </SemanticButton>

              <SemanticButton
                color="grey"
                icon
                labelPosition="right"
                onClick={() => changePage(1)}
              >
                Avançar
                <Icon name="right arrow" />
              </SemanticButton>
            </ContainerPaginate>
      </Box>
    </Box>
  );
};

export default withRouter(LogsVoittoCoins);
